import React, { FC } from 'react';
import { Switch } from 'react-router-dom';
import { AuthRoute } from '..';
import { StoreProvider, profileSettingsStore, customSettingsStore, permissionsStore } from '../..';
import { ProfileSettings, CustomSettings, Permissions } from '../../../view';
import * as urls from '../../../common/constants/urls';

const UserRoutes: FC = (): JSX.Element => {
	return (
		<Switch>
			<AuthRoute exact path={`${urls.PROFILE_SETTINGS_URL.value}/:id`}>
				<StoreProvider store={profileSettingsStore} page='profile-settings'>
					<ProfileSettings />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={`${urls.CUSTOM_SETTINGS_URL.value}/:id`}>
				<StoreProvider store={customSettingsStore} page='custom-settings'>
					<CustomSettings />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={`${urls.PERMISSIONS_URL.value}/:id`}>
				<StoreProvider store={permissionsStore} page='permissions'>
					<Permissions />
				</StoreProvider>
			</AuthRoute>
		</Switch>
	);
};

export { UserRoutes };
